/* eslint-env browser */
/* eslint-disable max-len */
import React from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { store } from './Store';
import AboutMunicipality from './Components/AboutMunicipality';
import AboutService from './Components/AboutService';
import AreaOverview from './Components/AreaOverview';
import StartPageComponent from './Components/StartPageComponent';
import Career from './Components/Career/Career';
import CompareFavouritesComponent from './Components/Compare/CompareFavouritesComponent';
import Licenses from './Components/Licenses';
import FrontPage from './Components/FrontPage';
import { setLanguage } from './Actions/LanguageActions';
import { getMunicipalityData } from './Actions/MunicipalityActions';
import { fetchCareers } from './Actions/CareerActions';
import {
  closeStartDropdown,
  openStartDropdown,
} from './Actions/ToggleActions';
import { URL_TYPES } from './Constants';
import { changeHtmlLang } from './Utils/otherUtils';

const preview = !!queryString.parse(window.location.search).preview;

const initApp = (match, hideDropDown) => {
  const { enableLinkTracking } = useMatomo();
  enableLinkTracking();

  if (match.params.municipalityName &&
      (!store.getState().MunicipalityReducer
      || store.getState().MunicipalityReducer.name !== match.params.municipalityName)) {
    store.dispatch(getMunicipalityData(match.params.lang, match.params.municipalityName));
    store.dispatch(fetchCareers(match.params.municipalityName));
  }

  store.dispatch(setLanguage(match.params.lang));

  if (hideDropDown === true) {
    store.dispatch(closeStartDropdown());
  } else if (hideDropDown === false) {
    store.dispatch(openStartDropdown());
  }

  const { params: { lang } } = match;
  changeHtmlLang(lang);

  if (preview) {
    window.history.pushState('', '', `${window.location.pathname}?preview=true`);
  }
};

const usePageViews = () => {
  const location = useLocation();
  const { trackPageView } = useMatomo();
  React.useEffect(() => {
    trackPageView();
  }, [location]);
};

export default () => {
  usePageViews();
  return (
    <Switch>
      <Route
        exact
        path="/"
        component={() => <Redirect to="/sv/" />}
      />
      <Route
        exact
        path="/:lang(sv|en)"
        component={({ match }) => {
          initApp(match);
          return <FrontPage />;
        }}
      />
      <Route
        exact
        path={`/:lang(sv|en)/${URL_TYPES.ABOUT_SERVICE}`}
        component={({ match }) => {
        initApp(match);
        return <AboutService match={match} />;
      }}
      />
      <Route
        exact
        path={`/:lang(sv|en)/${URL_TYPES.ABOUT_SERVICE}/${URL_TYPES.LICENSES}`}
        component={Licenses}
      />
      <Route
        exact
        path={`/:lang(sv|en)/:municipalityName/${URL_TYPES.ABOUT_MUNICIPALITY}`}
        component={({ match }) => {
        initApp(match);
        return <AboutMunicipality />;
      }}
      />
      <Route
        exact
        path={`/:lang(sv|en)/:municipalityName/${URL_TYPES.CAREER}/:careerName`}
        component={({ match }) => {
        initApp(match);
        return <Career match={match} />;
      }}
      />
      <Route
        exact
        path={`/:lang(sv|en)/:municipalityName/${URL_TYPES.AREA}/:areaName`}
        component={({ match }) => {
        initApp(match);
        return <AreaOverview match={match} />;
      }}
      />
      <Route
        exact
        path={`/:lang(sv|en)/:municipalityName/${URL_TYPES.COMPARE}`}
        component={({ match, location }) => {
        initApp(match);
        return <CompareFavouritesComponent match={match} location={location} />;
      }}
      />
      <Route
        path="/:lang(sv|en)/:municipalityName"
        component={({ match }) => {
          initApp(match);
          return <StartPageComponent />;
        }}
      />
      <Route
        exact
        path="/404"
        component={() => <Redirect to="/sv/" />}
      />

      <Route render={() => <Redirect to="/sv/" />} />
    </Switch>
  );
};



// WEBPACK FOOTER //
// ./src/Routes.js